import { useSurfacePreference } from "../../../hooks/use-surface-preference.ts"
import { surfaceKey } from "../../User/redux/ui-preferences.types.ts"

export type AlbumView = "grid" | "table"

// One key for album contents as a whole; a key per album per user would grow
// the preferences bag without bound.
export const ALBUM_VIEW_PREFERENCE_KEY = surfaceKey("project.album.view")

// Photos are the common case, and the album surface has always shown cards.
export const DEFAULT_ALBUM_VIEW: AlbumView = "grid"

export const useAlbumView = (): [AlbumView, (view: AlbumView | null) => void] =>
  useSurfacePreference<AlbumView>(ALBUM_VIEW_PREFERENCE_KEY, DEFAULT_ALBUM_VIEW)
